module.exports = __webpack_public_path__ + "img/P150T_weapon_114.5ee42f49.png";